const accountTypes = {
  SET_TRIAL_EXPIRED: 'SET_TRIAL_EXPIRED',
  SET_SUBSCRIPTION_EXPIRED: 'SET_SUBSCRIPTION_EXPIRED',
  SET_IN_APP_NOTIFICATION: 'SET_IN_APP_NOTIFICATION'
}

export { accountTypes }
